import Amplify from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    // OPTIONAL - customized storage object
    // 認証情報をどの単位で保存するかの設定
    // NULセキュリティレビューよりブラウザ単位ではなく、タブ単位を推奨されている
    storage: window.sessionStorage,

    //Authで利用するCognito設定情報を記載。AWSのコンソールCognito画面と整合を取る必要がある
    //ID/Pass認証の場合は使用しない。
    oauth: {
      domain: process.env.VUE_APP_COGNITO_USER_POOL_DOMAIN,
      scope: ["openid"],
      redirectSignIn: process.env.VUE_APP_LECO_TOP_URL + "/sso-redirect/",
      redirectSignOut: process.env.VUE_APP_LECO_TOP_URL + "/",
      responseType: "code"
    }
  }
});

import { CognitoUserPool } from "amazon-cognito-identity-js";
import { Config } from "aws-sdk";

// export default:他ファイルからの呼び出しを可能にする
export default class Cognito {
  //設定の更新
  configure(config) {
    if (config.userPool) {
      this.userPool = config.userPool;
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId
      });
    }
    Config.region = config.region;
    this.options = config;
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito;
      }
    });

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options);
        }
      }
    });
  };

  /**
   * username, passwordでサインアップ
   * username = emailとしてUserAttributeにも登録
   * Okta認証の場合は使用しない
   */
  async signUp(username, password, familyName, givenName) {
    const param = {
      username: username,
      password: password,
      attributes: {
        email: username,
        given_name: givenName,
        family_name: familyName
      }
    };
    try {
      await Auth.signUp(param);
      // console.debug("SignUp成功");
    } catch (err) {
      // console.error("SignUp失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * SSOログイン処理を行う関数
   */
  async federatedSignIn() {
    try {
      //Okta経由でSSOログイン処理を行う
      const user = await Auth.federatedSignIn({ provider: process.env.VUE_APP_COGNITO_IDENTITY_PROVIDER });
      // console.debug("SignIn成功");
      // console.debug("Auth.SignIn result:" + JSON.stringify(user));
      return user;
    } catch (err) {
      // console.error("SignIn失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * Cognitoログイン処理を行う関数
   */
   async login(username, password) {
    try {
      //Cognitoの認証情報を基にログイン処理を行う
      const user = await Auth.signIn(username, password);
      // console.debug("SignIn成功");
      // console.debug("Auth.SignIn result:" + JSON.stringify(user));
      return user;
    } catch (err) {
      // console.error("SignIn失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * ログアウト
   */
  async logout() {
    // console.log("ログアウトします");
    try {
      await Auth.signOut();
      // console.debug("SignOut成功");
    } catch (err) {
      // console.error("SignOut失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * ログインしているかの判定を行う
   * 認証があれば認証情報を、認証が無い場合Nullを返す
   */
  async checkAuthenticated() {
    // console.debug("認証状況チェック開始 ：checkAuthenticated");
    const cognitoUser = await Auth.currentSession();
    // console.debug("currentUserInfo:" + JSON.stringify(cognitoUser));
    // console.debug("認証状況チェック完了 ：checkAuthenticated");
    if (cognitoUser === null) {
      // console.warn("認証情報なし（cognitoUserなし）");
      return null;
    }
    // console.debug("認証情報あり");
    var exp_time = cognitoUser.idToken.payload.exp;
    var now = Math.floor(Date.now() / 1000);
    if (exp_time < now) {
      // console.error(
      //  "認証の有効期限が切れています。\n期限:" + exp_time + "、\n現在:" + now
      // );
      return null;
    } else {
      // console.debug(
      //  "認証の有効期限内です。\n期限:" + exp_time + "、\n現在:" + now
      // );
      return cognitoUser;
    }
  }

  /**
   * パスワード初期化のための認証コード送信
   * Okta認証の場合は使用しない
   */
  async forgotPassword(userId) {
    //    // console.log("パスワード初期化のための認証コードを送信します");
    try {
      const result = await Auth.forgotPassword(userId);
      // console.debug("forgotPassword成功:" + JSON.stringify(result));
      return result;
    } catch (err) {
      // console.error("forgotPassword失敗:" + userId);
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * パスワード忘れ時の再設定
   * Okta認証の場合は使用しない
   */
  async forgotPasswordSubmit(userId, verificationCode, newPassword) {
    //// console.log("パスワード忘れ時のパスワード初期化を行います");
    try {
      const result = await Auth.forgotPasswordSubmit(
        userId,
        verificationCode,
        newPassword
      );
      // console.debug("forgotPasswordSubmit成功:" + JSON.stringify(result));
      return result;
    } catch (err) {
      // console.error("forgotPasswordSubmit失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }

  /**
   * パスワード変更
   * Okta認証の場合は使用しない
   */
  async changePassword(user, nowPassword, newPassword) {
    // console.log("パスワード忘れ時のパスワード初期化を行います");
    try {
      await Auth.changePassword(user, nowPassword, newPassword);
      // console.debug("changePassword成功");
    } catch (err) {
      // console.error("changePassword失敗");
      // console.error(JSON.stringify(err));
      throw err;
    }
  }
}
